// ---------------------------------------------------------------------------
// TopRail — brand, school picker, week navigation and console actions.
// ---------------------------------------------------------------------------
import React, {useEffect, useRef, useState} from "react";
import {FILE_BASE_URL} from "../../../../constants/ApiConstant";

// Digital Ghanti mark (inline so the console has no external image dependency).
const LOGO_SRC =
    "data:image/png;base64,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";

const Chevron = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M2.5 4.5L6 8l3.5-3.5" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Resolve a school logo path from the dropdown response into a usable URL.
// Absolute URLs pass through; relative paths are prefixed with the file base.
function logoUrl(school) {
    const raw = school && school.logo;
    if (!raw) return null;
    return String(raw).startsWith("http") ? raw : `${FILE_BASE_URL}/${String(raw).replace(/^\/+/, "")}`;
}

// Square logo tile with the school's initial as a fallback when no logo exists.
function SchoolLogo({school, name}) {
    const [broken, setBroken] = useState(false);
    const src = logoUrl(school);
    if (src && !broken) {
        return <img className="slogo" src={src} alt="" onError={() => setBroken(true)} />;
    }
    return <span className="slogo slogo--ph">{(name || "?").trim().charAt(0).toUpperCase()}</span>;
}

// Custom school picker: a native <select> can't render per-option logos, so
// this is a lightweight dropdown showing a square logo beside each school.
function SchoolPicker({schools, schoolId, onSchoolChange, optLabel, onBackToOverall}) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const ref = useRef(null);
    const searchRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDoc = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open]);

    // Reset the query and focus the search box each time the menu opens.
    useEffect(() => {
        if (open) {
            setQuery("");
            const id = setTimeout(() => searchRef.current && searchRef.current.focus(), 0);
            return () => clearTimeout(id);
        }
        return undefined;
    }, [open]);

    const selected = schools.find((s) => String(s.id) === String(schoolId)) || null;

    const q = query.trim().toLowerCase();
    const filtered = q
        ? schools.filter((s) =>
              [s.name, s.name_ne, s.code, s.district]
                  .some((v) => v && String(v).toLowerCase().includes(q)),
          )
        : schools;

    return (
        <div className="field schoolpick" ref={ref}>
            <button
                type="button"
                className="picker"
                aria-haspopup="listbox"
                aria-expanded={open}
                disabled={schools.length === 0}
                onClick={() => setOpen((v) => !v)}
            >
                {selected ? (
                    <>
                        <SchoolLogo school={selected} name={selected.name} />
                        <span className="slabel">{optLabel(selected)}</span>
                    </>
                ) : (
                    <span className="slabel">{schools.length === 0 ? "Loading schools…" : "Select school"}</span>
                )}
            </button>
            <Chevron />
            {open && schools.length > 0 && (
                <div className="picker-menu" role="listbox">
                    <div className="picker-search">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.2" stroke="currentColor" strokeWidth="1.4" />
                            <path d="M9.2 9.2L12 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                        </svg>
                        <input
                            ref={searchRef}
                            type="text"
                            placeholder="Search school…"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                    </div>
                    <ul className="picker-list">
                        {onBackToOverall ? (
                            <li
                                role="option"
                                aria-selected={false}
                                className="picker-opt"
                                onClick={() => {
                                    onBackToOverall();
                                    setOpen(false);
                                }}
                            >
                                <span className="slogo slogo--ph">☰</span>
                                <span className="slabel">All schools (Overall)</span>
                            </li>
                        ) : null}
                        {filtered.length === 0 ? (
                            <li className="picker-empty">No schools found</li>
                        ) : (
                            filtered.map((s) => (
                                <li
                                    key={s.id}
                                    role="option"
                                    aria-selected={String(s.id) === String(schoolId)}
                                    className={`picker-opt ${String(s.id) === String(schoolId) ? "on" : ""}`}
                                    onClick={() => {
                                        onSchoolChange(String(s.id));
                                        setOpen(false);
                                    }}
                                >
                                    <SchoolLogo school={s} name={s.name} />
                                    <span className="slabel">{optLabel(s)}</span>
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
}

function TopRail({
    schools, schoolId, onSchoolChange, onBackToOverall, weekLabel, onPrev, onNext, canNext,
    isThisWeek, onThisWeek, onRefresh, onExport, lang, onToggleLang,
}) {
    const optLabel = (s) => {
        const name = lang === "ne" && s.name_ne ? s.name_ne : s.name;
        return s.code ? `${name} · ${s.code}` : name;
    };
    return (
        <header className="rail">
            <div className="brand">
                <img src={LOGO_SRC} alt="Digital Ghanti" />
                <div>
                    <span className="bt">
                        Digital Ghanti<sup style={{fontSize: "9px", top: "-.8em"}}>&reg;</sup>
                    </span>
                    <span className="bs en">Bell Operations Console</span>
                    <span className="bs ne">घण्टी सञ्चालन कन्सोल</span>
                </div>
            </div>
            <div className="rail-sep" />
            <div className="rail-tools">
                <span className="sr">School</span>
                <SchoolPicker
                    schools={schools}
                    schoolId={schoolId}
                    onSchoolChange={onSchoolChange}
                    optLabel={optLabel}
                    onBackToOverall={onBackToOverall}
                />

                <div className="weeknav">
                    <button onClick={onPrev} title="Previous week" aria-label="Previous week">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M8.5 3L4.5 7l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <span className="wlabel">{weekLabel}</span>
                    <button onClick={onNext} disabled={!canNext} title="Next week" aria-label="Next week">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M5.5 3l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>
                <button className={`ghost ${isThisWeek ? "on" : ""}`} onClick={onThisWeek}>
                    <span className="en">This week</span><span className="ne">यो हप्ता</span>
                </button>

                <button className="ghost" onClick={onRefresh} title="Refresh">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M12 7a5 5 0 1 1-1.6-3.7M12 1.5V4.5H9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className="en">Refresh</span><span className="ne">ताजा</span>
                </button>
                <button className="ghost" onClick={onExport} title="Download CSV">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M7 1.5v7m0 0L4.3 5.8M7 8.5l2.7-2.7M2 10.5v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    CSV
                </button>
                <button className="ghost lang" onClick={onToggleLang}>
                    {lang === "en" ? "नेपाली" : "English"}
                </button>
            </div>
        </header>
    );
}

export default TopRail;
